import React, { Component, Fragment } from 'react';
import { withTranslation } from "react-i18next";
import Header from "./Parts/Header";
import SubHeader from "./Parts/SubHeader";
import Loading from "./Parts/Loading";
import DidNotSignBy1Ct from "../ErrorPages/DidNotSignBy1Ct";

class Done extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step_count: 3,
            current_step: 4,
            redirect_url: null,
            redirect_timer_seconds: 15,
        };

        axios.post('/api/process/' + this.props.application_token + '/last_step', { step: 'done' })
            .catch((a, b, c) => {
                console.log(a, b, c);
            });

        this.handleTimer = this.handleTimer.bind(this);
        this.timer_interval = setInterval(this.handleTimer, 1000);
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.suggestion.application.id !== undefined
            && this.props.suggestion.application.id !== null
            && !localStorage.getItem(this.props.suggestion.application.id + ':sent')
        ) {
            gtm.sendEvent('conversion', {
                orderID: this.props.suggestion.application.id,
                amount: this.props.suggestion.amount,
                productType: this.props.suggestion.type,
                actionField: { step: 10, action: 'Contract signed'},
            });

            //new version
            gtm.sendEvent('base', {
                event: 'loan_contract_signing.completed',
                products: {
                    loan_amount: this.props.suggestion.amount,
                    loan_period: this.props.suggestion.term,
                    product_code: this.props.suggestion.application?.appl_product,
                    contract_id: this.props.suggestion.application.proposal?.contract_no,
                }
            }, 2);

            localStorage.setItem(this.props.suggestion.application.id + ':sent', true);
        }
    }

    componentWillUnmount() {
        clearInterval(this.timer_interval);
    }

    handleTimer() {
        let seconds = this.state.redirect_timer_seconds;

        if (seconds < 1) {
            clearInterval(this.timer_interval);
            this.setState({ redirect_url: this.props.suggestion.eshop_data.return_url });
        }

        this.setState({ redirect_timer_seconds: seconds - 1 });
    }

    render() {
        let { type, is_eshop, loading } = this.props.suggestion,
            isIndivyPlan = type === 'IP';

        if (!_.isNil(this.state.redirect_url) && (!_.isEmpty(type) && !isIndivyPlan)) {
            return window.location = this.state.redirect_url;
        }

        return (
            <Fragment>
                {this.props.should_repeat ?
                    <DidNotSignBy1Ct url={'/' + this.props.application_token + '/process/sign_contract'} />
                    :
                    <div>
                        <Header title={this.props.t('step.contract')} />

                        {is_eshop === null || loading ?
                            <Loading/>
                            :
                            <div className="section window-layout">
                                <div className="container frame">
                                    <SubHeader
                                        step_count={this.state.step_count}
                                        current_step={this.state.current_step}
                                    />

                                    <div className="row py-5">
                                        <div className="container py-5">
                                            <div className="col-12 d-flex justify-content-center">
                                                <span className="success-icon"><i
                                                    className="icons icon-check"></i></span>
                                            </div>
                                            <div className="col-12 d-flex justify-content-center text-center mt-4">
                                                <p className="heading--2">{this.props.t('forms.congratulations')}</p>
                                            </div>

                                            {is_eshop && !isIndivyPlan ?
                                                <div>
                                                    <div className="heading--3 text-center">
                                                        Netrukus būsite nukreipti atgal į&nbsp;
                                                        <a target="_blank" href={this.props.suggestion.eshop_data.return_url}>
                                                            el. parduotuvę
                                                        </a>:
                                                    </div>

                                                    <div className="text-center heading--2 text-primary mt-4">
                                                        {this.state.redirect_timer_seconds}
                                                    </div>
                                                </div>
                                                :
                                                <div className="col-12 d-flex justify-content-center text-center mt-4">
                                                    <p className="heading--3">{this.props.t('forms.you_can_find_info_on_site')}</p>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </Fragment>
        )
    }
}

export default withTranslation()(Done);
